<div class="events-container mt-5">
  @for(event of events; track event.subject) {
    <div class="event-card">
      <div class="event-header">
        <h3 class="event-title">{{ event.subject }}</h3>
        <span class="event-status">Próximo</span>
      </div>
      
      <div class="event-time">
        <div class="time-item time-start">
          <div class="time-icon">▶</div>
          <div class="time-text">Inicio: {{ event.start }}</div>
        </div>
        <div class="time-item time-end">
          <div class="time-icon">⏹</div>
          <div class="time-text">Fin: {{ event.end }}</div>
        </div>
      </div>

      <div class="attendees-section">
        <div class="attendees-title">
          <div class="attendees-icon">👥</div>
          Participantes ({{ event.attendees?.length || 0 }})
        </div>
        
        @if(event.attendees && event.attendees.length > 0) {
          <div class="attendees-list">
            @for(attendee of event.attendees; track attendee.email) {
              <div class="attendee-item">
                <div class="attendee-avatar">
                  {{ getInitials(attendee.name) }}
                </div>
                <div class="attendee-info">
                  <div class="attendee-name">{{ attendee.name }}</div>
                  <div class="attendee-email">{{ attendee.email }}</div>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="no-attendees">
            No hay participantes adicionales
          </div>
        }
      </div>
    </div>
  }
</div>